import {render} from 'react-dom';
import {Suspense} from 'react';
import {Provider} from 'react-redux';
import PulseApp, {STATUSES} from '@teladoc/pulse/ui/App';
import {BrowserRouter} from 'react-router-dom';
import APIUtils from '@livongo/utilities/system/api';
import {FeatureFlagProvider} from '@livongo/utilities/system/featureFlag';
import NewRelicUtils from '@livongo/utilities/system/newrelic';
import Arg from '@livongo/arg';
import createStore from 'store';
import i18n from 'i18n';
import MixpanelUtils from './common/mix-panel';
import App from './App';
import './index.scss';

APIUtils.init({
    baseUrl: window?.process?.env?.API_URL ?? process.env.API_URL,
});

// Update New Relic key values for this repository
const nrObject = {
    ACCOUNT_ID: window?.process?.env?.ACCOUNT_ID ?? process.env.ACCOUNT_ID,
    TRUST_KEY: window?.process?.env?.TRUST_KEY ?? process.env.TRUST_KEY,
    AGENT_ID: window?.process?.env?.AGENT_ID ?? process.env.AGENT_ID,
    LICENSE_KEY: window?.process?.env?.LICENSE_KEY ?? process.env.LICENSE_KEY,
    APPLICATION_ID:
        window?.process?.env?.APPLICATION_ID ?? process.env.APPLICATION_ID,
};

// Initialize New Relic
NewRelicUtils.init({document, nrObject});

MixpanelUtils.init(
    window?.process?.env?.MIXPANEL_TOKEN ?? process.env.MIXPANEL_TOKEN
);

const flag = window?.process?.env?.ENVIRONMENT ?? process.env.ENVIRONMENT;
const featureFlags = require(`feature-flags/${
    flag === 'local' || (flag !== 'production' && flag !== 'preprod')
        ? 'integration'
        : flag
}.json`);

render(
    <Suspense>
        <PulseApp
            i18n={i18n({lang: Arg('locale')})}
            render={({data, status}) => {
                switch (status) {
                    case STATUSES.INITIALIZED:
                        return (
                            <Provider store={createStore({})}>
                                <FeatureFlagProvider
                                    featureFlags={featureFlags}
                                >
                                    <BrowserRouter>
                                        <App />
                                    </BrowserRouter>
                                </FeatureFlagProvider>
                            </Provider>
                        );
                }
            }}
        />
    </Suspense>,
    document.querySelector('.root')
);
